<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <AmountSelectorListTeachNysDinner />
          <FormSection title="My contribution is in honor of:">
            <!---->
            <div>
              <FormRow
                class="designation-form-row"
                v-for="(item, index) in designations"
                :key="index"

                :class="{'rowidth__full': (index === designations.length - 1 &&
                    checkedDesignations.includes(item.value))}"
              >
                <label :for="'designation_' + index" class="pre-dinner__label">
                  <input
                    type="checkbox"
                    :id="'designation_' + index"
                    :value="item.value"
                    class="pre-dinner__checkbox pre-dinner__designations"
                    :checked="checkedDesignations.includes(item.value)"
                    @click="toggleDesignation(item.value, $event.target.checked)"
                  />
                  <span class="pre-dinner__text">{{ item.label }}</span>
                </label>
                <div v-if="
                    index === designations.length - 1 &&
                    checkedDesignations.includes(item.value)
                  ">
                <FormRow
                  class="full-width"
                >
                  <div style="width: 100%">
                    <FormLabel class="control-label"> In honor of: </FormLabel>
                    <input
                      type="text"
                      class="width-full"
                      v-model="honorOf"
                      ref="otherTextInput"
                    />
                  </div>
                </FormRow>
              </div>
              </FormRow>
              <div>
                <FormRow inline v-if="checkedDesignations.includes('In honor of my school')">
                  <FormCol field="custom.schoolHonorName" width="half" :showLabel="false">
                    <FormLabel class="control-label">Select a School: </FormLabel>
                    <FormSelect>
                      <option value="Bais Yaakov Ateres Miriam">Bais Yaakov Ateres Miriam</option>
                      <option value="Bais Yaakov of the Five Towns">Bais Yaakov of the Five Towns</option>
                      <option value="Bnos Bais Yaakov">Bnos Bais Yaakov</option>
                      <option value="DRS Yeshiva High School for Boys">
                        DRS Yeshiva High School for Boys
                      </option>
                      <option value="Gesher Early Childhood Center">
                        Gesher Early Childhood Center
                      </option>
                      <option value="Hebrew Academy of Five Towns and Rockaway (HAFTR)">
                        Hebrew Academy of Five Towns and Rockaway (HAFTR)
                      </option>
                      <option value="Hebrew Academy of Long Beach (HALB)">
                        Hebrew Academy of Long Beach (HALB, DRS, SKA)
                      </option>
                      <option value="Hebrew Academy of Nassau County (HANC)">
                        Hebrew Academy of Nassau County (HANC)
                      </option>
                      <option value="IVDU LI">IVDU LI</option>
                      <option value="Long Island Hebrew Academy">
                        Long Island Hebrew Academy
                      </option>
                      <option value="Mercaz Academy">Mercaz Academy</option>
                      <option value="Mesivta Netzach Hatorah">Mesivta Netzach Hatorah</option>
                      <option value="Mesivta Ateres Yaakov">Mesivta Ateres Yaakov</option>
                      <option value="North Shore Hebrew Academy">
                        North Shore Hebrew Academy
                      </option>
                      <option value="Rambam Mesivta">Rambam Mesivta</option>
                      <option value="Shulamith">Shulamith</option>
                      <option value="Solomon Schechter School of LI">
                        Solomon Schechter School of LI
                      </option>
                      <option value="The Brandeis School">The Brandeis School</option>
                      <option value="Torah Academy For Girls">Torah Academy For Girls</option>
                      <option value="Yeshiva Har Torah">Yeshiva Har Torah</option>
                      <option value="Yeshiva of Far Rockaway">Yeshiva of Far Rockaway</option>
                      <option value="Yeshiva Toras Chaim of South Shore">
                        Yeshiva Toras Chaim of South Shore
                      </option>
                      <option value="Yeshiva Darchei Torah">Yeshiva Darchei Torah</option>
                    </FormSelect>
                  </FormCol>
                </FormRow>
              </div>
            </div>
          </FormSection>
          <div
            v-if="
              (form.amount &&
                Number(form.amount) >= 250 &&
                getValue('custom.preK') !== 'journal') ||
              getValue('custom.preK') == 'yes'
            "
          >
            <FormSection title="Attendence & Journal">
              <div class="radio-part">
                <input
                  id="type_attending"
                  name="Attending"
                  type="radio"
                  :checked="getValue('custom.AttendInPerson') == 'yes'"
                  @click="setValue('custom.AttendInPerson', 'yes')"
                />
                <FormLabel for="type_attending">
                  I currently plan on attending in person
                </FormLabel>
              </div>
              <div class="radio-part">
                <input
                  name="Attending"
                  id="type_noattending"
                  type="radio"
                  :checked="getValue('custom.AttendInPerson') == 'no'"
                  @click="setValue('custom.AttendInPerson', 'no')"
                />
                <FormLabel for="type_noattending">
                  I currently do not plan on attending in person
                </FormLabel>
              </div>
              <ErrorLabel field="custom.AttendInPerson" />
              <div v-if="getValue('custom.AttendInPerson') == 'yes'">
                <br />
                <FormRow>
                  <div style="width: 100%">
                    <FormLabel class="control-label">
                      Names of Guests:
                    </FormLabel>
                    <FormInput type="textarea" class="width-full" field="custom.guests" />
                    <ErrorLabel field="custom.guests" />
                  </div>
                </FormRow>
                <FormRow>
                  <div style="width: 100%">
                    <FormLabel class="control-label">
                      Do you have any seating requests?
                    </FormLabel>
                    <FormInput
                      type="textarea"
                      class="width-full"
                      field="custom.seatingRequests"
                    />
                  </div>
                </FormRow>
              </div>
            </FormSection>
          </div>
          <div title="" v-if="form.amount && (Number(form.amount) > 500 || getValue('custom.preK') == 'journal')">
            <FormSection title="">
              <FormRow>
                <div style="width: 100%">
                  <FormLabel class="control-label">
                    Journal message:
                  </FormLabel>
                  <FormInput type="textarea" class="width-full" field="custom.journal" />
                  <ErrorLabel field="custom.journal" />
                </div>
              </FormRow>
            </FormSection>
          </div>

          <FormSection title="Payment Options">
            <div class="frequency">
              <PaymentOptions addSplit :splitMonths="12" />
            </div>
          </FormSection>

          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <div style="width: 100%">
                <FormLabel class="control-label">
                  Please print your name as you would like it to appear in the scroll of
                  honor: (Leave blank If you wish to be anonymous)
                </FormLabel>
                <FormInput type="text" class="width-full" field="custom.scrollhonor" />
              </div>
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://teachcoalition.org/privacy-policy/"/>
                  </FormRow>   
          </FormSection>
          <FormSection title="">
            <FormRow inline>
              <FormCol field="custom.schoolName" width="half" :showLabel="false">
                <FormLabel class="control-label"> School Affiliation: </FormLabel>
                <FormSelect>
                  <option value="Bnos Bais Yaakov">Bnos Bais Yaakov</option>
                  <option value="Bais Yaakov of the Five Towns">Bais Yaakov of the Five Towns</option>
                  <option value="DRS Yeshiva High School for Boys">
                    DRS Yeshiva High School for Boys
                  </option>
                  <option value="Gesher Early Childhood Center">
                    Gesher Early Childhood Center
                  </option>
                  <option value="Hebrew Academy of Five Towns and Rockaway (HAFTR)">
                    Hebrew Academy of Five Towns and Rockaway (HAFTR)
                  </option>
                  <option value="Hebrew Academy of Long Beach (HALB)">
                    Hebrew Academy of Long Beach (HALB, DRS, SKA)
                  </option>
                  <option value="Hebrew Academy of Nassau County (HANC)">
                    Hebrew Academy of Nassau County (HANC)
                  </option>
                  <option value="IVDU LI">IVDU LI</option>
                  <option value="Long Island Hebrew Academy">
                    Long Island Hebrew Academy
                  </option>
                  <option value="Mercaz Academy">Mercaz Academy</option>
                  <option value="Mesivta Netzach Hatorah">Mesivta Netzach Hatorah</option>
                  <option value="Mesivta Ateres Yaakov">Mesivta Ateres Yaakov</option>
                  <option value="North Shore Hebrew Academy">
                    North Shore Hebrew Academy
                  </option>
                  <option value="Rambam Mesivta">Rambam Mesivta</option>
                  <option value="Shulamith">Shulamith</option>
                  <option value="Solomon Schechter School of LI">
                    Solomon Schechter School of LI
                  </option>
                  <option value="Talmud Torah Siach Yitzchok">
                    Talmud Torah Siach Yitzchok
                  </option>
                  <option value="The Brandeis School">The Brandeis School</option>
                  <option value="Torah Academy For Girls">Torah Academy For Girls</option>
                  <option value="Yeshiva Har Torah">Yeshiva Har Torah</option>
                  <option value="Yeshiva of Far Rockaway">Yeshiva of Far Rockaway</option>
                  <option value="Yeshiva Toras Chaim of South Shore">
                    Yeshiva Toras Chaim of South Shore
                  </option>
                  <option value="Yeshiva Darchei Torah">Yeshiva Darchei Torah</option>
                </FormSelect>
              </FormCol>
            </FormRow>
          </FormSection>
          <FormSection title="">
            <DonorAddress />
          </FormSection>
          <FormSection title="Media Release Form">
            <MediaRelease />
          </FormSection>
          <FormSection title="Payment Information" last>
            <div class="payment-info">
              <FormRow>
                <PaymentType
                  cc_text="Credit Card"
                  check_text="Check / Donor Advised Fund"
                />
              </FormRow>
              <FormRow inline>
                <FormCol
                  class="doublepay"
                  field="card"
                  :showLabel="false"
                  check_text=""
                />
              </FormRow>
              <FormRow
                v-if="form.gateway === 'check'"
                style="justify-content: center"
                class="checktext"
              >
                <div>
                  Please mail your check to the following address:
                  <p style="text-align: center">
                    <strong
                      >Teach Coalition<br />
                      C/O Caleb Fischer<br />
                      40 Rector St, 4th Floor<br />
                      New York, NY 10006</strong
                    >
                  </p>
                </div>
              </FormRow>
            </div>
          </FormSection>
          <PaymentButton showAmount btnText="Pay now" />
          <p class="note">
            <br />All donations are tax-deductible to the full extent permitted by law.
          </p>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  onMounted,
  ref,
  watch,
  computed,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {
    subCampaign: String,
    campaign: String,
  },
  setup(props) {
    const { setValue, form, getValue, submit } = usePaymentForm();

    const honoOtherrOf = ref("");
    const honorOf = ref("");
    const honorOfSchool = ref(false);

    const designations = [      
      { label: "Naomi and Chesky Newman", value: "Naomi and Chesky Newman" },
      {
        label: "Rachelle Alter-Wernick and Bruce Wernick",
        value: "Rachelle Alter-Wernick and Bruce Wernick",
      },
      { label: "Mrs. Bluma Drebin", value: "Mrs. Bluma Drebin" },
      { label: "Dovi Safier", value: "Dovi Safier" },
      { label: "Lance Hirt", value: "Lance Hirt" },
      { label: "Maury Litwack", value: "Maury Litwack" },
      { label: "Sydney Altfield", value: "Sydney Altfield" },
      { label: "In honor of my school", value: "In honor of my school" },
      { label: "Teach NYS", value: "Teach NYS" },
      { label: "Other", value: "Other" },
    ];

    //@ts-ignore

    const checkedDesignations = ref<string[]>([]);
    const firstCheckbox = ref<HTMLInputElement | null>(null);
    const honoreesDesignation = ref("");

    const toggleDesignation = (value: string, checked: boolean) => {
      if (checked) {
        if (!checkedDesignations.value.includes(value)) {
          checkedDesignations.value.push(value);
        }
      } else {
        checkedDesignations.value = checkedDesignations.value.filter(v => v !== value);
      }
    };

    function concatenateStrings(arr: string[]): string {
      return arr.join(", ");
    }

    watch(firstCheckbox, (newVal) => {
      if (newVal && newVal.checked) {
        honoreesDesignation.value += ", " + newVal.value;
      }
    });

    watch(checkedDesignations, () => {
      let tempArray = [];
      let honorString = honorOf.value + checkedDesignations.value;
      tempArray = honorString.split(",")
      const index = tempArray.indexOf("Other");
      if (index > -1) { 
        tempArray.splice(index, 1); 
        //@ts-ignore
        setValue("custom.honorOf", tempArray);
      } else {
        //@ts-ignore
        setValue("custom.honorOf", checkedDesignations.value);
      }      
    });

    watch(honorOf, () => {
      let tempArray = [];
      let honorString = honorOf.value + checkedDesignations.value;
      tempArray = honorString.split(",")
      const index = tempArray.indexOf("Other");
      if (index > -1) { 
        tempArray.splice(index, 1); 
        //@ts-ignore
        setValue("custom.honorOf", tempArray);
      } else {
        //@ts-ignore
        setValue("custom.honorOf", checkedDesignations.value);
      } 
  
    })



    onMounted(() => {
      setValue("custom.AttendInPerson", "yes");

      if (props.subCampaign) {
        setValue("applications.0.subCampaign", props.subCampaign);
      }
      if (props.campaign) {
        setValue("applications.0.campaign", props.campaign);
      }

      const params = queryParams();
      if (params.utm_content) {
        if (
          !["Direct Mail", "Telemarketing", "Text SMS Message"].includes(
            params.utm_content
          )
        ) {
          throw new Error("Invalid subcampaign");
        }
        setValue("applications.0.subCampaign", params.utm_content);
      }
    });
    return {
      form,
      setValue,
      getValue,
      designations,
      checkedDesignations,
      toggleDesignation,
      firstCheckbox,
      honorOfSchool,
      honoreesDesignation,
      honorOf,
      submit,
    };
  },
});
</script>
<style scoped lang="scss">
.form-container.ou-donation-form {
  margin: 0px;
  padding: 0px;
  box-shadow: none;
  max-width: 100%;
}
h2 {
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 0px;
  font-size: 20px;
  color: black;
}
.selcted__note {
  border: none;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.note {
  font-style: italic;
  line-height: 1.4;
  font-weight: 500;
  font-size: 14px;

  a {
    text-decoration: none;
  }
}
::v-deep .amount-row {
  min-width: 31.3333% !important;
  max-width: 31.3333% !important;

  &.amount-row--wide {
    min-width: 65% !important;
    max-width: 65% !important;
  }
}

::v-deep label {
  line-height: normal !important;
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  gap: 2%;
  justify-content: flex-start;

  label {
    font-weight: 500;
    background: #122d3d !important;
    color: white !important;
    display: flex !important;
    line-height: normal;
    &:hover {
      background: black !important;
    }
  }
  input[type="radio"]:checked + label {
    background: #be9e5f !important;
  }

  textarea {
    padding: 5px 10px;
    font-family: inherit;
  }
  .label-description {
    background: none !important;
    display: block !important;
    text-align: center !important;
    font-size: 17px;
    font-style: italic;
    padding-top: 0;
    color: white !important;
  }
  .label-amount {
    background: none !important;
    display: block !important;
    height: auto !important;
    max-width: 100%;
    min-width: 100% !important;
    border: none !important;
    font-size: 18px;
    text-align: center;
  }
  #amount_other {
    max-width: 100%;
  }
  .amount_other__wrapper::before {
    background: #122d3d !important;
    color: white !important;
    font-weight: bold;
  }
  .amount_other__wrapper {
    margin-bottom: 18px;
  }
}

.radio-part {
  display: flex;
  gap: 10px;
  align-items: center;
  padding-bottom: 5px;
}
.radio-part label {
  margin: 0px;
  padding: 0px;
  line-height: normal;
}
.payment-info {
  p {
    margin-bottom: 20px;
  }
}

.designation-form-row.form-group.rowidth__full {
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
}
</style>
